<template>
  <section id="hero" data-component="hero">
    <LazyBg :src="bgSrc" eager />
    <canvas ref="canvasEl" id="hero-canvas">您的浏览器不支持 Canvas 动画</canvas>
    <div class="hero-overlay" />
    <div class="hero-content">
      <div class="hero-badge">
        <span class="hero-badge-dot" />
        关于海曦
      </div>
      <h1 class="display-xl hero-title">
        国产化AI算力<br /><span class="gradient-text">与智能解决方案领导者</span>
      </h1>
      <p class="hero-subtitle">
        以“自主可控、安全可信”为核心，构建从底层技术到场景落地的全链条 AI 能力体系，成为政企数字化转型中最可信赖的技术伙伴。
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import LazyBg from '@/components/LazyBg.vue';
import { useHeroCanvas } from '@/composables/useHeroCanvas';
import bgSrc from '@/assets/about_bg1.png';
import '@/styles/newhome/home/hero.css';

const canvasEl = ref<HTMLCanvasElement | null>(null);
useHeroCanvas(canvasEl);
</script>

<style scoped lang="scss">
.hero-overlay {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.45));
}
</style>
